"use client";
import React from "react";
import { Box, Typography } from "@mui/material";
import Image from "next/image";
import { motion } from "framer-motion";
import AppleStore from "../../assets/AppleStore.png";
import AndriodStore from "../../assets/AndroidStore.png";
// import AppImage from "../../assets/app-background.jpg";
// import Iphone from "../../assets/iphone.jpg";
import "./index.css";

const GetApp = () => {
  const appBenefits = [
    "Book faster on mobile",
    "Track offers and rewards",
    "Manage appointments instantly",
  ];

  const revealTransition = {
    initial: { opacity: 0, y: 18 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.3 },
    transition: { duration: 0.22, ease: "easeOut" as const },
  };

  return (
    <div
      style={{
        margin: "0 auto var(--salontym-section-gap)",
        width: "var(--salontym-content-width)",
      }}
      id="get-app-scroll"
    >
      <div className="hero">
        <div className="get-app-container">
          <div className="hero__inner">
            <motion.div className="hero__info" {...revealTransition}>
              <Typography className="section-eyebrow get-app-eyebrow">
                Mobile experience
              </Typography>
              <Typography
                component="h2"
                sx={{
                  fontSize: { xs: "2.2rem", sm: "3.4rem", lg: "3.9rem" },
                  fontWeight: 700,
                  lineHeight: { xs: 1.08, sm: 1.05 },
                  letterSpacing: "-0.04em",
                  maxWidth: "100%",
                  margin: { xs: "0.85rem 0 0", sm: "0.85rem 0 0" },
                  fontFamily: "var(--salontym-font-display)",
                }}
              >
                Get the SalonTym App
              </Typography>
              <Typography className="get-app-subtitle">
                Get a faster, smoother booking experience with offers, rewards,
                and appointments all in one polished mobile flow.
              </Typography>

              <Box className="get-app-benefits">
                {appBenefits.map((item) => (
                  <motion.div
                    key={item}
                    whileHover={{ y: -2 }}
                    transition={{ duration: 0.18, ease: "easeOut" }}
                  >
                    <Box className="get-app-benefit-pill">{item}</Box>
                  </motion.div>
                ))}
              </Box>

              <Typography className="get-app-download-label" variant="body1">
                Download the app from
              </Typography>
              <div className="get-app-logo">
                <a
                  href="https://apps.apple.com/in/app/salontym-salon-at-home/id6444617786"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    className="download"
                    src={AppleStore}
                    width={500}
                    height={200}
                    alt="Apple Store Download Button"
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.tym.salon.salontym&hl=en_IN"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    className="download"
                    src={AndriodStore}
                    width={500}
                    height={200}
                    alt="Android Store Download Button"
                  />
                </a>
              </div>
              <Typography className="get-app-footnote" variant="body2">
                Or continue browsing on www.salontym.com from your phone or desktop.
              </Typography>
            </motion.div>
            <motion.div
              className="hero__mockups"
              initial={{ opacity: 0, y: 18, scale: 0.985 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.24, ease: "easeOut" }}
            >
              <div className="get-app-preview-card">
                <div className="get-app-preview-top">
                  <div>
                    <Typography className="get-app-preview-kicker">
                      App highlights
                    </Typography>
                    <Typography className="get-app-preview-title">
                      Designed for repeat beauty rituals
                    </Typography>
                  </div>
                </div>
                <div className="get-app-preview-grid">
                  <div className="get-app-preview-stat">
                    <span>Quick booking</span>
                    <strong>2 taps</strong>
                  </div>
                  <div className="get-app-preview-stat">
                    <span>Reward-ready</span>
                    <strong>Coins + offers</strong>
                  </div>
                  <div className="get-app-preview-panel">
                    <Typography className="get-app-preview-panel-title">
                      Modern booking flow
                    </Typography>
                    <Typography className="get-app-preview-panel-copy">
                      Cleaner checkout, smoother rebooking, and better access to your memberships.
                    </Typography>
                  </div>
                  <div className="get-app-preview-panel get-app-preview-panel-alt">
                    <Typography className="get-app-preview-panel-title">
                      Built for everyday use
                    </Typography>
                    <Typography className="get-app-preview-panel-copy">
                      Save time while keeping the experience premium, calm, and reliable.
                    </Typography>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetApp;
